import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { PlatformBreadCrumbComponent } from './components/platform-breadcrumb/platform-breadcrumb.component';
import { PlatformBreadcrumbSharedModule } from '@ecap3/app-platform-breadcrumb-shared-module';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
@NgModule({
    imports: [
        MatIconModule,
        FlexLayoutModule.withConfig({
            useColumnBasisZero: false,
               printWithBreakpoints: ['xs', 'sm', 'md', 'lg', 'xl', 'lt-sm', 'lt-md', 'lt-lg', 'lt-xl', 'gt-xs', 'gt-sm', 'gt- md', 'gt-lg']
       }),
        RouterModule,
        CommonModule,
        TranslateModule,
        PlatformBreadcrumbSharedModule,
        MatMenuModule,
        MatButtonModule
    ],
    exports: [
        PlatformBreadCrumbComponent
    ],
    declarations: [
        PlatformBreadCrumbComponent
    ],
    providers: [
    ]
})
export class PlatformBreadCrumbModule { }
